/**
 * AuditSessionErrorDisplay Component
 *
 * Displays error state for audit session detail page when session loading fails.
 */

import { ErrorDisplay } from '@core/components/ErrorDisplay';

interface AuditSessionErrorDisplayProps {
  /** Error object with correlation ID and message */
  error: {
    correlationId?: string;
    message?: string;
    userMessage?: string;
  };
  /** Handler for closing the error display */
  onClose: () => void;
  /** Handler for retrying the operation */
  onRetry: () => void;
}

export function AuditSessionErrorDisplay({ error, onClose, onRetry }: AuditSessionErrorDisplayProps) {
  return (
    <ErrorDisplay
      isOpen
      correlationId={error.correlationId}
      message={error.message || error.userMessage || 'Failed to load audit session details.'}
      title="Error Loading Session"
      onClose={onClose}
      onRetry={onRetry}
    />
  );
}
